















































































































import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import { TagContentsParam } from "@/params/TagContentsParam";
import MusicSound from "@/media/MusicSound";
import AppEvent from "@/events/AppEvent";
import DialogCloseNavigation from "@/components/navigations/DialogCloseNavigation.vue";
import vuescroll from "vuescroll";

@Component({
  components: {
    DialogCloseNavigation,
    vuescroll
  }
})
export default class VrTagMusicDialog extends Vue {
  protected music: MusicSound;
  protected isMusicLoaded: boolean = false;
  protected isMusicPlay: boolean = false;
  protected seekBarLength = 0;
  protected bufferBarLength = 100;
  protected isSeekBarHover: boolean = false;

  protected scrollOptions: any = {
    vuescroll: {
      detectResize: true
    },
    bar: {
      background: '#8A56AC'
    }
  };

  @Prop() isShown: boolean;
  @Prop() contents: TagContentsParam;

  /* Computed Property */
  get publicPath (): string {
    return this.$store.state.publicPath;
  }

  get parentDom (): HTMLDivElement {
    const $parent: HTMLDivElement = <HTMLDivElement> this.$parent.$el;
    return $parent;
  }

  get isSmp (): boolean {
    return this.$store.state.isSmp;
  }

  get isShownDialog (): boolean {
    return this.isShown;
  }
  set isShownDialog (value: boolean) {
    if (!value) {
      this.onCloseDialog();
    }
  }

  get bufferBarStyle (): any {
    return {
      width: this.bufferBarLength + '%',
      height: this.isSeekBarHover ? '8px' : '4px'
    };
  }

  get vScroll (): vuescroll {
    return <vuescroll> this.$refs.vScroll;
  }


  /* Watcher */
  @Watch('isShown')
  onChangeShown (newValue, oldValue) {
    console.log('Shown: ' + newValue);
    if (!newValue) {
      this.stopMusic();
    }
  }


  mounted (): void {
    this.$nextTick(() => {
      this.loadMusic();
    })
  }


  /* Methods */
  protected loadMusic (): void {
    this.isMusicLoaded = false;

    if (!this.music) {
      this.music = new MusicSound(this.publicPath + this.contents.musicContents.soundUrl, 0.4);
    }
    else {
      this.music.soundSrc = this.publicPath + this.contents.musicContents.soundUrl;
    }

    this.music.addEventListener(AppEvent.LOAD_PROGRESS, this.onLoadMusicProgress);
    this.music.addEventListener(AppEvent.LOAD_COMPLETE, this.onLoadMusicComplete);
    this.music.load();
  }

  protected onLoadMusicProgress (ev: AppEvent): void {
    console.log('Progress: ' + ev.buffered);
    if (ev.buffered === 1) {
      this.music.removeAllEventListeners(AppEvent.LOAD_PROGRESS);
    }
    this.bufferBarLength = Math.round(ev.buffered * 100);
  }

  protected onLoadMusicComplete (ev: Event): void {
    console.log('On Load Music Complete: ' + this.contents.musicContents.musicName);
    this.music.removeAllEventListeners(AppEvent.LOAD_COMPLETE);
    this.isMusicLoaded = true;
    // もしこの時、バッファの数値がゼロの時は一度もProgressイベントが発火されないで
    // 再生完了になったという事なのでキャッシュの音源が使われていると
    // みなしバッファ量を100にする
    if (this.bufferBarLength === 0) {
      this.music.removeAllEventListeners(AppEvent.LOAD_PROGRESS);
    }
    this.bufferBarLength = 100;
  }

  /**
   * 音源の再生
   */
  protected playMusic (): void {
    if (this.music) {
      this.isMusicPlay = true;
      this.music.addEventListener(AppEvent.TIME_UPDATE, this.onTimeUpdate);
      this.music.addEventListener(AppEvent.END, this.stopMusic);
      this.music.play();
    }
  }

  /**
   * 音源の一時停止
   */
  protected pauseMusic (): void {
    this.isMusicPlay = false;
    this.music.removeAllEventListeners(AppEvent.TIME_UPDATE);
    this.music.removeAllEventListeners(AppEvent.END);
    this.music.pause();
  }

  /**
   * 音源の停止
   */
  protected stopMusic (): void {
    this.isMusicLoaded = false;
    this.isMusicPlay = false;
    this.music.removeAllEventListeners(AppEvent.TIME_UPDATE);
    this.music.removeAllEventListeners(AppEvent.END);
    this.music.stop();
    this.seekBarLength = 0;
  }


  /* Event Handler */
  /**
   * Playボタン押下時
   * @param ev
   */
  protected onClickPlayButton (ev: MouseEvent): void {
    if (this.isMusicPlay) {
      this.pauseMusic();
    }
    else {
      // BGMをOFFにする
      this.$store.commit('pauseBgm');
      this.playMusic();
    }
  }

  @Emit('close')
  protected onCloseDialog (): void {
    this.music.removeAllEventListeners(AppEvent.LOAD_PROGRESS);
    this.music.removeAllEventListeners(AppEvent.LOAD_COMPLETE);
    this.stopMusic();
    // BGMをONにする
    this.$store.commit('playBgm');
    setTimeout(() => {
      this.vScroll.scrollTo({x:0, y:0}, 0);
    }, 300);
  }


  protected onSeekBarHover (ev: MouseEvent): void {
    if (this.isSmp) { return; }
    this.isSeekBarHover = true;
  }

  protected onSeekBarOut (ev: MouseEvent): void {
    if (this.isSmp) { return; }
    this.isSeekBarHover = false;
  }


  protected onUpdateSeek (ev: MouseEvent): void {
    const $seekBar: any = this.$refs.seekBarBox;
    const $bar: HTMLDivElement = $seekBar.$el;
    const barWidth: number = $bar.clientWidth;
    const mouseX: number = ev.offsetX;
    this.seekBarLength = Math.round(mouseX / barWidth * 100);
    this.music.currentTime = Math.round(this.music.duration * (mouseX / barWidth));
  }

  protected onTimeUpdate (ev: AppEvent): void {
    console.log('TimeUpdate: ' + ev);
    this.seekBarLength = (this.music.currentTime / this.music.duration) * 100;
  }
}
